import React from "react";
import Navbar from "./Navbar";
import { BsPinMapFill } from "react-icons/bs";
import Footer from "../Footer/Footer";
import "./OurSpecialPromo.css";
import tiptopgo from "../../assets/1 (1).png";
import tiptopgo2 from "../../assets/tiptopgo.png";
import andriod from "../../assets/andriod-removebg-preview.png";
import apple from "../../assets/apple.png";

const OurSpecialPromo = () => {
  return (
    <div>
      <Navbar />

      <section className='promo-hero'>
        <img src={tiptopgo} alt='' className='promo-hero__bg' />
        <div className='promo-hero__overlay' />
        <div className='container'>
          <div className='promo-hero__content'>
            <div className='promo-hero__eyebrow'>Residency Hotels</div>
            <h1 className='promo-hero__title'>Special Promo & Offers</h1>
            <p className='promo-hero__desc'>
              Enjoy discounted rates, complimentary upgrades, dining credits,
              spa offers, and late checkout. Treat yourself to an unforgettable
              stay. Book now! Limited time offer.
            </p>
          </div>
        </div>
      </section>
      <svg
        className='promo-hero__wave'
        viewBox='0 0 1440 100'
        preserveAspectRatio='none'
      >
        <path
          d='M0,55 C240,100 480,0 720,40 C960,80 1200,10 1440,55 L1440,100 L0,100 Z'
          fill='#fff'
        />
      </svg>

      <div className='container promoPage'>

        <div className='row'>
          <div className='col-md-6'>
            <div className='card'>
              <img src={tiptopgo} className='card-img-top2' alt='...' />
              <div className='card-body'>
                <p className='card-title pb-2 title'>
                  Book Residency Hotel from tiptopgo.com
                </p>
                <p className='sub'>
                  Get amazing discount and promo
                </p>
                <p className='card-text desc'>
                  Enjoy an amazing discount when you book Residency hotel using
                  Tiptopgo.com. weekend getaway here is always interesting, as a
                  guest you’re at liberty to make use of our outdoor swimming
                  pool as you enjoy cool music playing from our rooftop surround
                  speakers. While in the pool our sommelier can suggest Wine or
                  Hot that suits the moment to you. Our Wi-Fi is available to
                  use free of charge for our guest, so make it a date and we
                  promise to make your weekend getaway a memorable one.
                </p>
                <button className='btn btn-primary webbtn'>
                  <a href='https://www.tiptopgo.com' target='_blank'>
                    Get discount
                  </a>
                </button>
              </div>
            </div>
          </div>

          <div className='col-md-6'>
            <div className='card'>
              <img src={tiptopgo2} className='card-img-top2' alt='...' />
              <div className='card-body'>
                <p className='card-title pb-2 title'>
                  Download Tiptopgo.com on your mobile device
                </p>
                <p className='sub'>
                  Get mindblowing discount when you book Residency from tiptopgo.com
                </p>
                <p className='card-text desc'>
                  Experience the best at Residency Hotels! Enjoy incredible
                  discounts on our services, and when you book with
                  tiptopgo.com, you'll receive even more exclusive savings. Join
                  us at the poolside bar for live music every Thursday to
                  Saturday, where nostalgic classNameics blend seamlessly with
                  Afropop and local tunes from legends like Chief Stephen Osita
                  Osadebe and King Sunny Ade. Stay fit and active in our
                  state-of-the-art gym, open for your convenience. Start
                  planning your weekend getaway with us today!
                </p>
                <div className='storeButtons'>
                  <button className='btnStyle'>
                    <a
                      href='https://play.google.com/store/apps/details?id=com.intellims.tiptopgo'
                      target='_blank'
                    >
                      <img src={andriod} alt='Android' />
                    </a>
                  </button>
                  <button className='btnStyle'>
                    <a
                      href='https://apps.apple.com/ng/app/tiptopgo/id6444825263'
                      target='_blank'
                    >
                      <img src={apple} alt='Apple' />
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OurSpecialPromo;
